import { useMutation } from "@tanstack/react-query";
import { getChatApiClient } from "@shared/apis/sidekick/api-factories";

export const usePinThread = () => {
  const chatApi = getChatApiClient();
  const mutation = useMutation({
    mutationFn: async (params: { threadId: string; pinned: boolean }) => {
      try {
        const response = await chatApi.chatControllerPinThread({
          thread: params.threadId,
          pinThreadRequest: {
            pinned: params.pinned,
          },
        });
        return response;
      } catch (error) {
        console.error(
          `Failed to pin/unpin thread. ID: ${params.threadId}`,
          error
        );
        throw error;
      }
    },
  });

  return mutation;
};
